import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe, NgClass, NgForOf, NgIf} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {forkJoin} from 'rxjs';
import {first, switchMap, take, tap} from 'rxjs/operators';
import { merge } from 'es-toolkit';
import {BaseService} from '../services/base.service';
import {SitesService} from '../services/sites.service';
import {DisplayPipe} from "../pipes/display.pipe";
import {FormsModule} from '@angular/forms';
import {HelpDocsLinksComponent} from '../help-docs-links/help-docs-links.component';
import {NgbDatepickerModule, NgbDropdown, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [
        NgClass,
        NgIf,
        FormsModule,
        HelpDocsLinksComponent,
        NgForOf,
        NgbDropdownModule,
        NgbDatepickerModule
    ],
    providers: [DatePipe, DisplayPipe]
})
export class SearchComponent implements OnInit {
  @Input() showFilter: any;
  @ViewChild('filterMenu') filterMenu: NgbDropdown;
  searchText: string;
  activeFilters: any[] = [];
  public currentDataset: string;
  public filter: { [key: string]: any } = {isopen: false};
  location: Location;
  villages: any[];
  filterSettings: any;
  public date_format = 'yyyy-MM-dd HH:mm';

  beaches_under_advisory_choices: any;
  precerclis_exposures: any;
  solidwaste_complaint_status: any;
  precerclis_circumstances: any;
  one_stop_permit_types: any;
  oane_stop_permit_types: any;

  public dateOptions = {
    showWeeks: false,
    showButtonBar: false
  };
  public open = {};

  urlParams: URLSearchParams;
  precerclisService: BaseService;
  solidwastePermitsService: BaseService;
  onestopPermitsService: BaseService;

  public interestOptions: { id: string; label: string; ticked?: boolean }[];
  private sitesService: BaseService;

  constructor(http: HttpClient, private sites: SitesService, private datePipe: DatePipe,
              private displayPipe: DisplayPipe, public router: Router, public activatedRoute: ActivatedRoute,
              @Inject('environment') private environment) {
    this.precerclisService = new BaseService(`${environment.baseUrl}/precerclis/sites`, http);
    this.solidwastePermitsService = new BaseService(`${environment.baseUrl}/solidwaste/permits`, http);
    this.onestopPermitsService = new BaseService(`${environment.baseUrl}/onestop/permits`, http);
    this.sitesService = new BaseService(`${environment.baseUrl}/sites`, http);
  }

  ngOnInit() {
    this.interestOptions = this.sites.interestOptions;
    this.sitesService.get<any>('metadata').subscribe(response => {
      this.villages = response.fields.village.all_choices;
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.activeFilters = [];
      this.searchText = params.search;
      Object.keys(params).filter(k => k !== 'search').forEach(key => {
        if (params[key]) {
          const value = params[key]
          key = key === 'interests' ? 'selectedInterests' : key;
          this.setActiveFilter(key, value);
        }
      });
    });
  }


  setActiveFilter(key, value) {
    if ((key === 'selectedInterests' || key === 'dataset') && value) {
      if (Array.isArray(value)) {
        value.forEach(v => {
          const interest = this.interestOptions.find(f => f.id === v);
          this.activeFilters.push({type: key, display: interest.label, id: interest.id});
        });
      } else if (typeof value === 'string') {
        value = value.split(',');
        this.filter.selectedInterests = value;
        const selectedValues = this.interestOptions.filter(x => value.includes(x.id));
        selectedValues.forEach(v => {
          this.activeFilters.length = 0;
          this.activeFilters.push({type: key, display: v.label, id: v.id});
          const index = this.interestOptions.indexOf(v);
          this.interestOptions[index].ticked = true;
        });
      }
    } else {
      this.filter[key] = value;
    }

    if (key === 'edit_start' && value) {
      if (typeof value === 'string') {
        value = new Date(value);
      }
      this.filter[key] = value;
      this.activeFilters.push({
        type: key,
        display: 'Last Edited After: ' + this.datePipe.transform(this.filter.edit_start, 'shortDate')
      });
    }
    if (key === 'edit_end' && value) {
      if (typeof value === 'string') {
        value = new Date(value);
      }
      this.filter[key] = value;
      this.activeFilters.push({
        type: key,
        display: 'Last Edited Before: ' + this.datePipe.transform(this.filter.edit_end, 'shortDate')
      });
    }
    if (key === 'solidwaste_complaint_type' && value) {
      this.activeFilters.push({
        type: key,
        display: 'Complaint Type: ' + value
      });
    }
    if (key === 'solidwaste_complaint_date_after' && value) {
      if (typeof value === 'string') {
        value = new Date(value);
      }
      this.activeFilters.push({
        type: key,
        display: 'Complaint Received After: ' + this.datePipe.transform(value, 'shortDate')
      });
    }
    if (key === 'solidwaste_complaint_date_before' && value) {
      if (typeof value === 'string') {
        value = new Date(value);
      }
      this.activeFilters.push({
        type: key,
        display: 'Complaint Received Before: ' + this.datePipe.transform(value, 'shortDate')
      });
    }
    if (key === 'village' && value) {
      this.activeFilters.push({
        type: key,
        display: this.displayPipe.transform(value, this.villages)
      });
    }
    if (key === 'precerclis_exposure' && value) {
      this.activeFilters.push({
        type: key,
        display: this.displayPipe.transform(this.filter.precerclis_exposure, this.precerclis_exposures)
      });
    }
    if (key === 'precerclis_circumstance' && value) {
      this.activeFilters.push({
        type: key,
        display: this.displayPipe.transform(this.filter.precerclis_circumstance, this.precerclis_circumstances)
      });
    }
    if (key === 'solidwaste_complaint_status' && value) {
      return this.get_solidwaste_statuses().pipe(tap(() => {
        this.activeFilters.push({
          type: key,
          display: `Complaint Status: ${this.displayPipe.transform(this.filter.solidwaste_complaint_status, this.solidwaste_complaint_status)}`
        });
      })).toPromise();
    }
    if (key === 'needs_review' && value) {
      this.activeFilters.push({type: key, display: 'Needs Review'});
    }
    if (key === 'beaches_under_advisory' && value) {
      if (value === true) {
        this.activeFilters.push({type: key, display: 'Under Advisory'});
      } else if (value === false) {
        this.activeFilters.push({type: key, display: 'Not Under Advisory'});
      }
    }
    if (key === 'ust_past_due_actions' && value) {
      this.activeFilters.push({type: key, display: 'Past Due Enforcement Actions'});
    }
    if (key === 'one_stop_permit_type' && value) {
      return this.get_one_stop_permit_type_choices().then(() => {
        this.activeFilters.push({
          type: key,
          display: this.displayPipe.transform(this.filter.one_stop_permit_type, this.one_stop_permit_types)
        });
      });
    } else if (key === 'one_stop_permit_type') {
    }
  }


  public applyFilter() {
    this.filterMenu.close();
    // this.sites.clearFilterParams();

    //                this.activeFilters = [];
    this.activeFilters = [];
    const promises = [];
    Object.keys(this.filter).forEach(key => {
      this.setActiveFilter(key, this.filter[key]);
    });
    if (this.filter.hasOwnProperty('selectedInterests')) {
      this.filter.dataset = this.filter.selectedInterests.join(',');
      this.filter.interests = this.filter.selectedInterests.join(',');
    }
    if (this.filter.hasOwnProperty('edit_start') && this.filter.edit_start) {
      this.filter.edit_start = this.filter.edit_start.toISOString();
    }
    if (this.filter.hasOwnProperty('edit_end') && this.filter.edit_end) {
      this.filter.edit_end = this.filter.edit_end.toISOString();
    }
    // forkJoin(promises).pipe(tap(() => {
    // Object.keys(this.sites.searchParam).forEach(key => {
    //   const params = {};
    //   params[key] = this.sites.searchParam[key];
    this.router.navigate(['site', 'list'], {queryParams: this.filter, queryParamsHandling: 'merge'});
    // this.$state.transitionTo('root.site.list', this.filter, {notify: false, reload: false});
    // });
    this.filter.isopen = false;
    // return this.sites.search();
    // })).subscribe();
  }

  public clearSelectedFilter(filter) {
    if (filter.type === 'selectedInterests' || filter.type === 'dataset') {
      let item = this.filter.selectedInterests.find(f => f === filter.id);
      let index = this.filter.selectedInterests.indexOf(item);
      this.filter.selectedInterests.splice(index, 1);
      item = this.interestOptions.find(f => f.id === filter.id);
      index = this.interestOptions.indexOf(item);
      this.interestOptions[index].ticked = false;
    } else if (filter.type === 'needs_review') {
      this.filter[filter.type] = null;
    } else if (filter.type === 'beaches_under_advisory') {
      this.filter[filter.type] = null;
    } else {
      this.filter[filter.type] = '';
    }
    this.applyFilter();
  }

  public clearFilters() {
    // this.sites.loading = true;
    // this.activeFilters = [];

    // this.sites.clearFilterParams();
    this.filter.selectedInterests = [];
    this.filter.edit_start = '';
    this.filter.edit_end = '';
    this.filter.village = '';
    this.filter.island = '';
    this.filter.precerclis_exposure = '';
    this.filter.precerclis_circumstance = '';
    this.filter.solidwaste_complaint_status = '';
    this.filter.needs_review = null;
    this.filter.beaches_under_advisory = null;
    this.filter.one_stop_permit_type = '';

    this.interestOptions.forEach((relatedOption, index) => {
      this.interestOptions[index].ticked = false;
    });
    this.activeFilters = [];
    this.applyFilter();
  }

  public clearTextSearch() {
    this.router.navigate(['site', 'list'], {queryParams: {search: ''}, queryParamsHandling: 'merge'});
    // this.$state.transitionTo('root.site.list', this.$state.params, {notify: false, reload: false});
    // this.sites.search().subscribe();
  }

  public search() {
    this.router.navigate(['site', 'list'], {queryParams: {search: this.searchText}, queryParamsHandling: 'merge'});
  }

  public openCalendar(e, date) {
    this.open[date] = true;
  }

  public get_precerclis_exposure_choices() {
    return this.precerclisService.get<any>('metadata').pipe(tap(response => {
      this.precerclis_exposures = response.fields.exposurepathway.choices;
      this.precerclis_circumstances = response.fields.circumstances.choices;
    }));
  }

  public get_solidwaste_statuses() {
    return this.solidwastePermitsService.get<any>('metadata').pipe(tap(response => {
      this.solidwaste_complaint_status = response.fields.status.choices;
    }));
  }


  public get_one_stop_permit_type_choices() {
    return new Promise<void>(resolve => {
      if (this.one_stop_permit_types !== undefined) {
        resolve();
      } else {
        this.onestopPermitsService.get<any>('metadata').pipe(tap(response => {
          this.oane_stop_permit_types = response.fields.type.choices;
          resolve();
        }));
      }
    });
  }
}
